// removed by extract-text-webpack-plugin
module.exports = {"main":"CreateRoute-main--gJdM9","border":"CreateRoute-border--306r4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateRoute/CreateRoute.scss
// module id = wNIN
// module chunks = 4